import baseDomain from './baseDomain';

export default function getBaseUrl(sitecode) {
  return `https://${sitecode ? `${sitecode}.` : ''}${baseDomain()}`;
}
